import React, { useContext, useMemo } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { AgGridReact } from '@ag-grid-community/react';
import { defaultGridHeight } from './utils';
import { CategorySpendBenchmarkContext } from 'contexts/CategorySpendBenchmark';

const SpendAboveBenchmarkExplore = () => {
	const { gridData } = useContext(CategorySpendBenchmarkContext);
	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`List of categories with spend greater than median benchmarks (category spend as % of total indirect spend).`}
				</AnalysisDescription>
				<TableContainer>
					<div style={gridStyle} className="ag-theme-balham">
						<AgGridReact {...gridData} />
					</div>
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default SpendAboveBenchmarkExplore;
